export default __webpack_public_path__ + "static/media/more.14116a21.svg";